import React from 'react';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 w-full z-50 py-2 px-4 text-center text-sm font-medium tracking-wide" style={{
    background: '#D4A853',
    color: '#0D1B2A',
    fontFamily: 'DM Sans, sans-serif'
  }} data-id="element-312">
      ⏰ 9,97 $ · Offre limitée · 100 mamans seulement
    </div>;
}